import { ComponentSettings, FieldTypes, empty } from "../settings/settings";

export const field = {
  name: {
    type: FieldTypes.value,
    text: { de: "Benutzername", en: "User name", nl: "Gebruikersnaam" },
    mutable: true,
    required: true,
  },
  firstName: {
    type: FieldTypes.value,
    text: { de: "Vorname", en: "First Name", nl: "Voornaamm" },
    mutable: true,
    required: true,
  },
  lastName: {
    type: FieldTypes.value,
    text: { de: "Nachname", en: "Last Name", nl: "Achternaam" },
    mutable: true,
    required: true,
  },
  userName: {
    type: FieldTypes.value,
    text: { de: "Benutzername", en: "Username", nl: "gebruikersnaam" },
    mutable: true,
    required: true,
  },
  email: {
    type: FieldTypes.value,
    text: { de: "Email", en: "Email", nl: "e-mail" },
    regex: "^[0-9a-zA-Z]+(?:.[0-9a-zA-Z]+)*@[a-zA-Z0-9]{2,}(?:.[a-zA-z]{2,})+$",
  },
  language: {
    type: FieldTypes.options,
    text: { de: "Sprache", en: "Language", nl: "Taal" },
    required: true,
    options: {
      en: {
        text: {
          de: "Englisch",
          en: "English",
          nl: "Engels",
        },
      },
      de: {
        text: {
          de: "Deutsch",
          en: "German",
          nl: "Duits",
        },
      },
      nl: {
        text: {
          de: "Niederländisch",
          en: "Dutch",
          nl: "Nederlandse",
        },
      },
    },
  },
  roles: {
    type: FieldTypes.options,
    text: { de: "Rollen", en: "Roles", nl: "Rollen" },
    multiple: false,
    required: true,
    options: {
      admin: {
        text: {
          de: "Administrator",
          en: "Admin",
          nl: "Beheerder",
        },
      },
      analyst: {
        text: {
          de: "Analyst",
          en: "Analyst",
        },
      },
      guest: {
        text: {
          de: "Gast",
          en: "Guest",
          nl: "Gast",
        },
      },
      team: {
        text: {
          de: "Team",
          en: "Team",
          nl: "Team",
        },
      },
      user: {
        text: {
          de: "Benutzer",
          en: "User",
          nl: "Gebruiker",
        },
      },
      RMAdmin: {
        text: {
          de: "RM Admin",
          en: "RM Admin",
          nl: "RM Admin",
        },
      },
    },
  },
  jobTitle: {
    type: FieldTypes.options,
    text: { de: "Funktion", en: "Function", nl: "Functie" },
    multiple: false,
    options: {},
  },
  oldPassword: {
    text: { de: "Altes Passwort", en: "Old Password", nl: "Oud wachtwoord" },
    persist: true,
    type: FieldTypes.password,
    search: false,
  },
  password: {
    text: { de: "Passwort", en: "Password", nl: "Wachtwoord" },
    type: FieldTypes.password,
    required: true,
    search: false,
  },
  retypePassword: {
    text: {
      de: "Passwort wiederholen",
      en: "Retype Password",
      nl: "Wachtwoord herhalen",
    },
    type: FieldTypes.password,
    required: true,
    search: false,
  },

  businessArea: {
    type: FieldTypes.options,
    text: {
      de: "Geschäftsfelder",
      en: "Business Area",
      nl: "Bedrijfssectoren",
    },
    options: {
      REGIO: {
        text: {
          de: "Regio",
          en: "Regio",
          nl: "Regio",
        },
      },
      CARGO: {
        text: {
          de: "Cargo",
          en: "Cargo",
        },
      },
      FERNVERKEHR: {
        text: {
          de: "Fernverkehr",
          en: "Long-distance",
          nl: "Intercity",
        },
      },
      FZ: {
        text: {
          de: "FZI",
          en: "FZI",
        },
      },
      SONSTIGE: {
        text: {
          de: "Sonstige",
          en: "Other",
          nl: "Overige",
        },
      },
    },
    search: false,
  },
  active: {
    text: { de: "Aktiv", en: "Active", nl: "Actief" },
    type: FieldTypes.checkbox,
    checkboxLabels: {
      true: { text: { de: "Active", en: "Active", nl: "Active" } },
      false: { text: { de: "Offline", en: "Offline", nl: "Offline" } },
    },
    options: {
      true: { text: { de: "Active", en: "Active", nl: "Active" } },
      false: { text: { de: "Offline", en: "Offline", nl: "Offline" } },
    },
  },
  passwordExpireDate: {
    type: FieldTypes.timestamp,
    text: {
      de: "Passwort gültig bis",
      en: "Password valid until",
      nl: "Wachtwoord geldig tot",
    },
    search: false,
  },
  displayAsComponent: {
    text: {
      de: "Komponent Verantwortlicher?",
      en: "Display as component responsible?",
      nl: "Component verantwoordelijk?",
    },
    type: FieldTypes.checkbox,
    search: false,
  },
  lastChangedPassword: {
    type: FieldTypes.timestamp,
    text: {
      de: "Passwort geändert",
      en: "Password changed",
      nl: "Wachtwoord gewijzigd",
    },
    search: false,
  },
  forcePasswordChangeOnFirstLogin: {
    text: {
      de: "Passwortänderung bei der ersten Anmeldung erzwingen",
      en: "Force password change on first login",
      nl: "Wachtwoord wijziging afdwingen bij de eerste login",
    },
    type: FieldTypes.checkbox,
    search: false,
  },
  passwordNeverExpire: {
    text: {
      de: "Password läuft nie ab",
      en: "Password does not expire",
      nl: "Wachtwoord vervalt nooit",
    },
    type: FieldTypes.checkbox,
    search: false,
  },
  remember: {
    type: FieldTypes.checkbox,
    text: {
      de: "Eingeloggt bleiben",
      en: "Keep me signed in",
      nl: "Blijf ingelogd",
    },
    search: false,
  },
  lastFivePasswords: {
    type: FieldTypes.data,
    text: {
      de: "Last five passwords",
      en: "Last five passwords",
      nl: "Last five passwords",
    },
    search: false,
  },
  projectNumber: {
    type: FieldTypes.options,
    text: {
      de: "Projekt Nr.",
      en: "Project Nr.",
      nl: "Project Nr.",
    },
    options: {
      PUMA: {
        text: {
          de: "SPz PUMA",
          en: "SPz PUMA",
          nl: "SPz PUMA",
        },
      },
      BOXER: {
        text: {
          de: "Boxer",
          en: "Boxer",
          nl: "Boxer",
        },
      },
      DINGO: {
        text: {
          de: "Dingo2L",
          en: "Dingo2L",
          nl: "Dingo2L",
        },
      },
      LEO: {
        text: {
          de: "KPz Leopard 2",
          en: "KPz Leopard 2",
          nl: "KPz Leopard 2",
        },
      },
    },
    search: false,
  },
  businessManager: {
    text: {
      de: "Business Manager",
      en: "Business Manager",
      nl: "Business Manager",
    },
    type: FieldTypes.checkbox,
  },
};

const settings = {
  permission: {
    manage: false,
    editOwn: false,
    addExpiryDate: false,
    manageProfile: false,
  },
  list: {
    columns: empty,
    boxes: empty,
    main: empty,
    personProfile: empty,
    readonlyView: [],
    fieldsOnFilter: empty,
    filterBoxesUser: empty,
    usersCsvExportColumns: empty,
  },
  url: {},
  text: {
    user: { de: "Benutzer", en: "User", nl: "Gebruiker" },
    add: {
      de: "Neuen Benutzer anlegen",
      en: "Add new user",
      nl: "Nieuwe gebruiker aanmaken",
    },
    main: {
      de: "Benutzer (Details)",
      en: "User (details)",
      nl: "Gebruiker (details)",
    },
    save: {
      de: "Änderungen übernehmen",
      en: "Save changes",
      nl: "Veranderingen bewaren",
    },
    close: {
      de: "Detailansicht schließen",
      en: "Close detail view",
      nl: "Detailweergave sluiten",
    },
    delete: {
      de: "Benutzer löschen",
      en: "Delete user",
      nl: "Gebruiker verwijderen",
    },
    deactivateUser: {
      de: "Benutzer deaktivieren",
      en: "Deactivate User",
      nl: "Gebruiker deactiveren",
    },
    deleted: {
      de: "Benutzer erfolgreich gelöscht",
      en: "User succesfully deleted",
      nl: "Gebruiker succesvol verwijderd",
    },
    discard: {
      de: "Sind Sie sicher, dass Sie die Änderungen verwerfen wollen?",
      en: "Are you sure you want to discard changes?",
      nl: "Weet je zeker dat je de wijzigingen wilt verwijderen?",
    },
    deleteMessage: {
      de: "Möchten Sie diesen Benutzer wirklich entfernen?",
      en: "Do you really want to remove this user?",
      nl: "Do you really want to remove this user?",
    },
    modalTitle: {
      de: "Bestätigung",
      en: "Confirm",
      nl: "Bevestigen",
    },
    messageInvalidForm: {
      de: "Die folgenden Felder sind ungültig:",
      en: "The following fields are invalid:",
      nl: "De volgende velden zijn ongeldig:",
    },
    errorRetypedPassword: {
      de: "Die Passwörter stimmen nicht überein.",
      en: "Retyped password is different.",
      nl: "Opnieuw getypt wachtwoord is anders.",
    },
    successUserCreated: {
      de: "Benutzer wurde erfolgreich angelegt.",
      en: "User created successfully.",
      nl: "Gebruiker succesvol aangemaakt.",
    },
    succesUserUpdated: {
      de: "Benutzer erfolgreich aktualisiert",
      en: "User updated successfully",
      nl: "Gebruiker succesvol bijgewerkt.",
    },
    userAlreadyExists: {
      de: "Benutzer existiert bereits",
      en: "User already exists",
      nl: "Gebruiker bestaat al.",
    },
    usernameNotAccepted: {
      de: "Ungültiger Benutzername! Die einzigen akzeptierten Sonderzeichen sind - und _",
      en: "Invalid user name! The only accepted special characters are - and _",
      nl: "Ongeldige gebruikersnaam! De enige toegestane speciale tekens zijn - en _",
    },
    emailNotAccepted: {
      de: "E-Mail-Adresse existiert bereits",
      en: "Email already exists!",
      nl: "E-mailadres bestaat al",
    },
    passwordNotString: {
      de: "Das Passwort ist keine Zeichenfolge",
      en: "Password is not a string",
      nl: "Wachtwoord is geen string.",
    },
    passwordCount1: {
      de: "Das Passwort ist nicht mindestens ",
      en: "Password is not at least ",
      nl: "Wachtwoord is niet ten minste ",
    },
    passwordCount2: {
      de: " Zeichen lang",
      en: " characters long",
      nl: " tekens lang",
    },
    passwodSpecialCharacters: {
      de: "Das Passwort enthält keines der folgenden Sonderzeichen: ",
      en: "Password does not contain one of the following special characters: ",
      nl: "Wachtwoord bevat niet een van de volgende speciale tekens: ",
    },
    passwordUsed: {
      de: "Das Passwort wurde bereits verwendet. Bitte verwenden Sie ein anderes!",
      en: "Password has been used before. Please use another one!",
      nl: "Wachtwoord is al eerder gebruikt. Gebruik alstublieft een andere!",
    },
    passwordNumber: {
      de: "Das Passwort enthält keine Nummer",
      en: "Password does not contain a number",
      nl: "Wachtwoord bevat geen cijfer.",
    },
    users: {
      en: "User Management",
      de: "Benutzermanagement",
      nl: "Gebruikersbeheer ",
    },
    create: {
      de: "Neuen Benutzer anlegen",
      en: "Create new user",
      nl: "Nieuwe gebruiker aanmaken",
    },
    edit: {
      de: "Speichern",
      en: "Save",
      nl: "Bewaar",
    },
    discardBtn: {
      de: "Änderungen",
      en: "Cancel",
      nl: "Annuler",
    },
    allOn: {
      de: "Alle ein",
      en: "All ON",
      nl: "allemaal UIT",
    },
    allOff: {
      de: "Alle aus",
      en: "All OFF",
      nl: "alle AAN",
    },
    closeBtn: { de: "Schließen", en: "Close" },
    closeWindow: {
      de: "Fenster schließen",
      en: "Close window",
      nl: "Venster sluiten",
    },
    emailNotif: {
      de: "Wir werden Sie per E-Mail benachrichtigen, wenn eine der folgenden Aktionen durchgeführt wird",
      en: "We'll email you when one off the following actions will happen",
      nl: "We sturen je een e-mail wanneer een van de volgende acties plaatsvindt",
    },
    tooltipAllOn: {
      de: "Alle E-Mails einschalten",
      en: "Set all emails on",
      nl: "Zet alle e-mails op",
    },
    tooltipAllOff: {
      de: "Alle E-Mails ausschalten",
      en: "Set all emails off",
      nl: "Alle e-mails uitzetten",
    },
    userInfo: {
      de: "Informationen für den Benutzer",
      en: "User Information",
      nl: "Informatie voor de gebruiker",
    },
    emailPref: {
      de: "E-Mail-Einstellungen",
      en: "E-Mail Preferences",
      nl: "E-mail voorkeuren",
    },
    userList: { de: "Benutzerliste", en: "User List", nl: "User List" },
    entraStatusConnected: {
      de: "Verbunden",
      en: "Connected",
      nl: "Verbonden",
    },
    entraStatusNotConnected: {
      de: "Nicht verbunden",
      en: "Not connected",
      nl: "Niet verbonden",
    },
    entraStatusNotConnectedHint: {
      de: "Microsoft Entra ID ist für Ihre Organisation noch nicht konfiguriert",
      en: "Microsoft Entra ID is not yet configured for your organization",
      nl: "Microsoft Entra ID is nog niet geconfigureerd voor uw organisatie",
    },
    entraConnectButton: {
      de: "Autorisieren",
      en: "Authorize",
      nl: "Autoriseren",
    },
    entraReConnectButton: {
      de: "Neu autorisieren",
      en: "Re-authorize",
      nl: "Opnieuw autoriseren",
    },
    entraHelpLink: {
      de: "Warum autorisieren?",
      en: "Why authorize?",
      nl: "Waarom autoriseren?",
    },
    entraConnectedOn: {
      de: "Verbunden am",
      en: "Connected on",
      nl: "Verbonden op",
    },
    entraName: {
      de: "Name",
      en: "Name",
      nl: "Naam",
    },
    entraTenantId: {
      de: "Mieter-ID",
      en: "Tenant ID",
      nl: "Huurder-ID",
    },
    entraSubtext: {
      de: "Verbinden Sie diesen Kunden mit einem Microsoft Entra-Mandanten, um Single Sign-On und eine zentralisierte Zugriffskontrolle zu ermöglichen.",
      en: "Link this customer to a Microsoft Entra tenant to enable single sign-on and centralized access control.",
      nl: "Koppel deze klant aan een Microsoft Entra-tenant om eenmalige aanmelding en gecentraliseerde toegangscontrole mogelijk te maken.",
    },
    entraSection1Title: {
      de: "Bequemlichkeit",
      en: "Convenience",
      nl: "Gemak",
    },
    entraSection1Text: {
      de: "Benutzer können sich mit ihren Microsoft-Arbeitskonten anstelle separater Passwörter anmelden.",
      en: "Users can sign in with their Microsoft work accounts instead of separate passwords.",
      nl: "Gebruikers kunnen zich aanmelden met hun Microsoft-werkaccounts in plaats van met aparte wachtwoorden.",
    },
    entraSection2Title: {
      de: "Zugriffsverwaltung",
      en: "Access Management",
      nl: "Toegangsbeheer",
    },
    entraSection2Text: {
      de: "Der Zugriff wird über Entra ID-Zuweisungen und Rollen in Ihrem Mandanten verwaltet.",
      en: "Access is managed through Entra ID assignments and roles in your tenant.",
      nl: "De toegang wordt beheerd via Entra ID-toewijzingen en rollen in uw tenant.",
    },
    entraSection3Title: {
      de: "Sicherheit",
      en: "Security",
      nl: "Beveiliging",
    },
    entraSection3Text: {
      de: "Sie können den Zugriff jederzeit zentral über Entra ID widerrufen.",
      en: "You can revoke access centrally from Entra ID at any time.",
      nl: "U kunt de toegang op elk moment centraal intrekken vanuit Entra ID.",
    },
  },
  field,
  additionalInfo: {},
};

export const user: ComponentSettings<typeof settings> = settings;
